<!-- MobileNav.vue -->

<script>
import { gsap } from 'gsap';

export default {

    data() {
      return {
        isOpen: false,
      };
    },
  // ... other component options ...

  methods: {
    toggleNavigation() {

      this.isOpen = !this.isOpen;

        const toggleNav = document.querySelector('.toggleNav');


      // element with class "click-exit" is the button that closes the navigation
        const clickExit = document.querySelector('.click-exit');
        console.log(clickExit);
        if (this.isOpen) {
            clickExit.classList.remove('hidden');
            toggleNav.classList.add('active');
        } else {
            clickExit.classList.add('hidden');
            toggleNav.classList.remove('active');
        }

      // GSAP animation
      gsap.to('.mobile-navigation', {
        duration: 0.3,
        x: this.isOpen ? 0 : '-100%',
        ease: 'power2.inOut',
      });
    },
  },
};
</script>

<template>
 
    <!-- Button to toggle the mobile navigation -->
    <div class="flex md:hidden shrink items-center justify-center"><button @click="toggleNavigation" class="toggleNav"></button></div>

    <button @click="toggleNavigation" class="click-exit hidden md:hidden h-svh absolute top-0 bg-black opacity-50 w-1/5 right-0">1</button>
    <div class="mobile-navigation h-svh absolute top-0 left-0 bg-black w-4/5 md:hidden flex flex-col p-8 gap-6 pt-24 z-50" :class="{ 'open': isOpen }">
        <!-- Navigation content goes here -->
        <router-link to="/" @click="toggleNavigation" class="text-white text-2xl font-serif border-b border-green-100 pb-4">Home</router-link>
        <a href="https://www.marker-ai.com/the-platform" class="text-white text-2xl font-serif border-b border-green-100 pb-4">The Platform</a>
        <router-link to="/resources" @click="toggleNavigation" class="text-white text-2xl font-serif border-b border-green-100 pb-4">Resources</router-link>
        <a href="https://www.marker-ai.com/about" class="text-white text-2xl font-serif border-b border-green-100 pb-4">About Us</a>
        <a href="https://www.marker-ai.com/pricing" class="text-white text-2xl font-serif border-b border-green-100 pb-4">Pricing</a>
        <a href="https://www.marker-ai.com/contact-us" class="text-white text-2xl font-serif border-b border-green-100 pb-4">Contact</a>

        <!-- Country Flags -->
        <div class="flex items-center gap-4 pt-2">
            <router-link to="/" @click="toggleNavigation" title="United Kingdom"><span class="text-2xl">🇬🇧</span></router-link>
            <router-link to="/uae" @click="toggleNavigation" title="UAE"><span class="text-2xl">🇦🇪</span></router-link>
            <router-link to="/us" @click="toggleNavigation" title="United States"><span class="text-2xl">🇺🇸</span></router-link>
            <router-link to="/australia" @click="toggleNavigation" title="Australia"><span class="text-2xl">🇦🇺</span></router-link>
            <router-link to="/canada" @click="toggleNavigation" title="Canada"><span class="text-2xl">🇨🇦</span></router-link>
        </div>
    </div>
  </template>
  
  
  <style scoped>
  /* Add Tailwind CSS classes for styling the navigation */
  .mobile-navigation {
    /* Your styling for the closed navigation */
    transition: transform 0.3s ease-in-out;
    transform: translateX(-100%);
  }
  
  .mobile-navigation.open {
    /* Your styling for the open navigation */
    transform: translateX(0);
  }
  </style>